<template>
  <div>
    <p
      v-if="isLoadedNormal"
      class="mb-2"
      :class="banClass"
    >
      {{getBanStatusStr}}
    </p>

    <div
      v-if="isLoadedNormal"
      class="top-panel"
    >
      <b-button v-b-modal.help-modal>Help</b-button>

      <b-button
        v-if="isBanButtonVisible"
        :to="{name: 'player_ban_add', params: {playerId: playerId, targetRoute: 'player_ban_log'}}"
        variant="primary"
      >
        Ban
      </b-button>

      <b-button
        v-if="isUnbanButtonVisible"
        :to="{name: 'player_unban_add', params: {playerId: playerId}}"
        variant="primary"
      >
        Unban
      </b-button>
    </div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template
      v-if="log !== null && log.length > 0"
    >
      <player-ban-log-item
        v-for="item in log"
        :key="createItemKey(item)"
        :playerId="playerId"
        :object="item"
        :userMap="userMap"
        class="mb-3"
      />
    </template>

    <loading-indicator v-if="isLoading"/>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показан <strong>журнал блокировок игрока</strong>.
          В&nbsp;журнале блокировок хранится информация
          о&nbsp;блокировках и&nbsp;разблокировках.
          Для каждой блокировки и разблокировки сохраняется пользователь,
          который выполнил данное действие, и&nbsp;причина.
        </p>
        <p>
          Блокировка может быть временной и&nbsp;постоянной.
          При&nbsp;временной блокировке игроку запрещается доступ к&nbsp;игре на&nbsp;определенное количество дней.
          При&nbsp;постоянной блокировке игроку запрещается доступ к&nbsp;игре на&nbsp;неограниченное время.
        </p>
        <p>
          Администраторы и модераторы имеют право разблокировать игрока.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth.js';

import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { isPlayerBanned        } from '../model/player_ban.js';
import { getPlayerBanStatusStr } from '../model/player_ban.js';

import { convertUserArrayToMap } from '../model/user.js';

import { mayBanPlayer as utilMayBanPlayer     } from '../util.js';
import { mayUnbanPlayer as utilMayUnbanPlayer } from '../util.js';

import LoadingIndicator from './LoadingIndicator.vue';
import PlayerBanLogItem from './PlayerBanLogItem.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerBanLog',

  components: {
    LoadingIndicator,
    PlayerBanLogItem,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadingStatus: LOADING_STATUS__INIT,

      banData: null,
      log: null,
      userMap: null,

      nowSec: Date.now() / 1000,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    mayBanPlayer() {
      return utilMayBanPlayer(this.actor.role);
    },

    mayUnbanPlayer() {
      return utilMayUnbanPlayer(this.actor.role);
    },

    message() {
      if(this.log !== null && this.log.length === 0) {
        return 'Ban log is empty.';
      }
      return null;
    },

    isBanned() {
      return isPlayerBanned(this.banData, this.nowSec);
    },

    getBanStatusStr() {
      return getPlayerBanStatusStr(this.banData, this.nowSec)
    },

    banClass() {
      return {
        banned: this.isBanned,
      };
    },

    /** @returns {boolean} */
    isBanButtonVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      if(!this.mayBanPlayer) {
        return false;
      }

      return !this.isBanned;
    },

    /** @returns {boolean} */
    isUnbanButtonVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      if(!this.mayUnbanPlayer) {
        return false;
      }

      return this.isBanned;
    },
  },

  created() {
    this.loadBanLog();
  },

  methods: {
    loadBanLog() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/player/${this.playerId}/ban_log`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.userMap = convertUserArrayToMap(data.users);
        this.banData = data.banData;

        const log = data.log;
        log.sort((a, b) => b.ctime - a.ctime);

        this.log = log;

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    createItemKey(item) {
      return item.type.toString() + '_' + item.id.toString();
    },
  },
};
</script>

<style scoped>
.top-panel {
  margin-bottom: 1em;
}

.banned {
  color: var(--red);
}
</style>
